import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { InventoryManagerComponent } from './inventory-manager/inventory-manager.component';
import { AddInventoryManagerComponent } from './add-inventory-manager/add-inventory-manager.component';
import { EmpDetailsComponent } from './emp-details/emp-details.component';

import { SelectportComponent } from './selectport/selectport.component';
import { ServiceOfferedComponent } from './service-offered/service-offered.component';
import { AddServiceOfferedComponent } from './add-service-offered/add-service-offered.component';

import { ServiceListComponent } from './service-list/service-list.component';
import { AddServiceListComponent } from './add-service-list/add-service-list.component';

import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { CustomerSchedularComponent } from './customer-schedular/customer-schedular.component';
import { CustomerSchedularListComponent } from './customer-schedular-list/customer-schedular-list.component';
import { ServiceCategoryComponent } from './service-category/service-category.component';
import { AddServiceCategoryComponent } from './add-service-category/add-service-category.component';
import { CustomerReportComponent } from './customer-report/customer-report.component';
import { EmployeeReportComponent } from './employee-report/employee-report.component';



import { PackageCategoryComponent } from './package-category/package-category.component';
import { AddPackageCategoryComponent } from './add-package-category/add-package-category.component';

import { PackageComponent } from './package/package.component';
import { AddPackageComponent } from './add-package/add-package.component';
import { BillingComponent } from './billing/billing.component';

import { DiscountOffersComponent } from './discount-offers/discount-offers.component';
import { AddDiscountOffersComponent } from './add-discount-offers/add-discount-offers.component';
import { CouponComponent } from './coupon/coupon.component';
import { AddCouponComponent } from './add-coupon/add-coupon.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { InvoiceReportComponent } from './invoice-report/invoice-report.component';
import { PrintBillingComponent } from './print-billing/print-billing.component';
import { PrintPreviewComponent } from './print-preview/print-preview.component';
import { AddProductComponent } from './add-product/add-product.component';
import { SellProductComponent } from './sell-product/sell-product.component';
import { AddUsablesComponent } from './add-usables/add-usables.component';
import { ProductsInServiceComponent } from './products-in-service/products-in-service.component';
import { ServicesInProductComponent } from './services-in-product/services-in-product.component';
import { ProductReportComponent } from './product-report/product-report.component';
import { ProductUsageReportComponent } from './product-usage-report/product-usage-report.component';
import { DynamicReportComponent } from './dynamic-report/dynamic-report.component';
import { TransactionalsmsComponent } from './transactionalsms/transactionalsms.component';
import { PromotionalsmsComponent } from './promotionalsms/promotionalsms.component';
import { TransactionalSmsReportComponent } from './transactional-sms-report/transactional-sms-report.component';
import { PromotionalsmsReportComponent } from './promotionalsms-report/promotionalsms-report.component';
import { MaxDisComponent } from './max-dis/max-dis.component';
import { AddMaxDisComponent } from './add-max-dis/add-max-dis.component';
import { MembershipComponent } from './membership/membership.component';
import { MembershipSetupComponent } from './membership-setup/membership-setup.component';
import { VeiwMemBillComponent } from './veiw-mem-bill/veiw-mem-bill.component';
import { MemReportComponent } from './mem-report/mem-report.component';
import { OfferReportComponent } from './offer-report/offer-report.component';
import { PrintCusBillComponent } from './print-cus-bill/print-cus-bill.component';
import { WhatsAppTemplateComponent } from './whats-app-template/whats-app-template.component';
import { AddWhatsAppTemplateComponent } from './add-whats-app-template/add-whats-app-template.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { DocumentsComponent } from './documents/documents.component';
import { IncentiveSetupComponent } from './incentive-setup/incentive-setup.component';
import { PartnershipSetupGridComponent } from './partnership-setup-grid/partnership-setup-grid.component';
import { PartnershipSetupComponent } from './partnership-setup/partnership-setup.component';
import { PartnershipReportComponent } from './partnership-report/partnership-report.component';
import { CustomerPartnershipReportComponent } from './customer-partnership-report/customer-partnership-report.component';
import { IncentiveSetupGridComponent } from './incentive-setup-grid/incentive-setup-grid.component';
import { AccessControlPanelComponent } from './access-control-panel/access-control-panel.component';
import { UploadComponent } from './upload/upload.component';
import { DailyAttendanceComponent } from './daily-attendance/daily-attendance.component';
import { AttendanceDashboardComponent } from './attendance-dashboard/attendance-dashboard.component';
import { WeeklyRosterComponent } from './weekly-roster/weekly-roster.component';
import { WeekOffManagementComponent } from './week-off-management/week-off-management.component';
import { MonthlyClaendarComponent } from './monthly-claendar/monthly-claendar.component';
import { ComboComponent } from './combo/combo.component';
import { ComboCategoryComponent } from './combo-category/combo-category.component';
import { AddComboCategoryComponent } from './add-combo-category/add-combo-category.component';
import { AddComboComponent } from './add-combo/add-combo.component';
import { PackageReceiptComponent } from './package-receipt/package-receipt.component';
import { AddSalonComponent } from './add-salon/add-salon.component';
import { ManageSalonsComponent } from './manage-salons/manage-salons.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { MetaTemplateApprovalComponent } from './meta-template-approval/meta-template-approval.component';
import { PackageReportComponent } from './package-report/package-report.component';
import { BulkWhatsappComponent } from './bulk-whatsapp/bulk-whatsapp.component';
import { WhatsappChatComponent } from './whatsapp-chat/whatsapp-chat.component';
import { WhatsAppSentReportComponent } from './whatsapp-sent-report/whatsapp-sent-report.component';
import { WhatsappCampaignReportComponent } from './whatsapp-campaign-report/whatsapp-campaign-report.component';
import { CreditsHistoryComponent } from './credits-history/credits-history.component';



const routes: Routes = [
  { path: '', component: LoginComponent, pathMatch: 'full' },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'cp', component: AccessControlPanelComponent, canActivate: [AuthGuard] },
  { path: 'upload', component: UploadComponent, canActivate: [AuthGuard] },
  { path: 'Selectport', component: SelectportComponent, canActivate: [AuthGuard] },
  { path: 'Serviceoffered', component: ServiceOfferedComponent, canActivate: [AuthGuard] },
  { path: 'add-Serviceoffered', component: AddServiceOfferedComponent, canActivate: [AuthGuard] },
  { path: 'add-Serviceoffered/:service_offered_id', component: AddServiceOfferedComponent, canActivate: [AuthGuard] },
  { path: 'add-Serviceoffered/:service_offered_id/view/:view_id', component: AddServiceOfferedComponent, canActivate: [AuthGuard] },

  { path: 'service-category', component: ServiceCategoryComponent, canActivate: [AuthGuard] },
  { path: 'add-Service-category', component: AddServiceCategoryComponent, canActivate: [AuthGuard] },
  { path: 'add-Service-category/:service_category_id', component: AddServiceCategoryComponent, canActivate: [AuthGuard] },
  { path: 'add-Service-category/:service_category_id/view/:view_id', component: AddServiceCategoryComponent, canActivate: [AuthGuard] },

  { path: 'combo-category', component: ComboCategoryComponent, canActivate: [AuthGuard] },
  { path: 'add-combo-category', component: AddComboCategoryComponent, canActivate: [AuthGuard] },
  { path: 'add-combo-category/:service_category_id', component: AddComboCategoryComponent, canActivate: [AuthGuard] },
  { path: 'add-combo-category/:service_category_id/view/:view_id', component: AddComboCategoryComponent, canActivate: [AuthGuard] },


  { path: 'combo', component: ComboComponent, canActivate: [AuthGuard] },
  { path: 'add-combo', component: AddComboComponent, canActivate: [AuthGuard] },
  { path: 'add-combo/:service_offered_id', component: AddComboComponent, canActivate: [AuthGuard] },
  { path: 'add-combo/:service_offered_id/view/:view_id', component: AddComboComponent, canActivate: [AuthGuard] },

  { path: 'package', component: PackageComponent, canActivate: [AuthGuard] },
  { path: 'add-package', component: AddPackageComponent, canActivate: [AuthGuard] },
  { path: 'add-package/:service_offered_id', component: AddPackageComponent, canActivate: [AuthGuard] },
  { path: 'add-package/:service_offered_id/view/:view_id', component: AddPackageComponent, canActivate: [AuthGuard] },

  { path: 'billings', component: BillingComponent, canActivate: [AuthGuard] },

  { path: 'discount-offers', component: DiscountOffersComponent, canActivate: [AuthGuard] },
  { path: 'add-discount-offers', component: AddDiscountOffersComponent, canActivate: [AuthGuard] },
  { path: 'add-discount-offers/:service_offered_id', component: AddDiscountOffersComponent, canActivate: [AuthGuard] },
  { path: 'add-discount-offers/:service_offered_id/type/:type', component: AddDiscountOffersComponent, canActivate: [AuthGuard] },
  { path: 'add-discount-offers/:service_offered_id/type/:type/view/:view_id', component: AddDiscountOffersComponent, canActivate: [AuthGuard] },
  { path: 'maxdis', component: MaxDisComponent, canActivate: [AuthGuard] },
  { path: 'add-maxdis/:service_category_id', component: AddMaxDisComponent, canActivate: [AuthGuard] },
  { path: 'add-maxdis/:service_category_id/brandName/:brand_name', component: AddMaxDisComponent, canActivate: [AuthGuard] },

  { path: 'invoice-report', component: InvoiceReportComponent, canActivate: [AuthGuard] },
  { path: 'print', component: PrintBillingComponent, canActivate: [AuthGuard] },
  { path: 'print-preview', component: PrintPreviewComponent, canActivate: [AuthGuard] },
  { path: 'checkout', component: CheckoutComponent, canActivate: [AuthGuard] },
  { path: 'coupon', component: CouponComponent, canActivate: [AuthGuard] },
  { path: 'add-coupon', component: AddCouponComponent, canActivate: [AuthGuard] },
  { path: 'add-coupon/:service_offered_id', component: AddCouponComponent, canActivate: [AuthGuard] },
  { path: 'add-coupon/:service_offered_id/view/:view_id', component: AddCouponComponent, canActivate: [AuthGuard] },
  { path: 'add-coupon/:service_offered_id/type/:type', component: AddCouponComponent, canActivate: [AuthGuard] },

  { path: 'Servicelist', component: ServiceListComponent, canActivate: [AuthGuard] },
  { path: 'add-Servicelist', component: AddServiceListComponent, canActivate: [AuthGuard] },
  { path: 'add-Servicelist/:service_list_id', component: AddServiceListComponent, canActivate: [AuthGuard] },
  { path: 'add-Servicelist/:service_list_id/view/:view_id', component: AddServiceListComponent, canActivate: [AuthGuard] },
  { path: 'customer-detail', component: CustomerDetailsComponent, canActivate: [AuthGuard] },
  { path: 'customer-detail/:scheduler_id', component: CustomerDetailsComponent, canActivate: [AuthGuard] },
  { path: 'customer-scheduler', component: CustomerSchedularComponent, canActivate: [AuthGuard] },
  { path: 'customer-scheduler/:scheduler_id', component: CustomerSchedularComponent, canActivate: [AuthGuard] },
  { path: 'customer-scheduler/:scheduler_id/view/:view_id', component: CustomerSchedularComponent, canActivate: [AuthGuard] },
  { path: 'customer-scheduler-list', component: CustomerSchedularListComponent, canActivate: [AuthGuard] },

  { path: 'viewMemBill', component: VeiwMemBillComponent, canActivate: [AuthGuard] },
  { path: 'veiwPackBill', component: PackageReceiptComponent, canActivate: [AuthGuard] },

  { path: 'partnership-grid', component: PartnershipSetupGridComponent, canActivate: [AuthGuard] },
  { path: 'add-partnership', component: PartnershipSetupComponent, canActivate: [AuthGuard] },
  { path: 'add-partnership/:partnership_id', component: PartnershipSetupComponent, canActivate: [AuthGuard] },
  { path: 'add-partnership/:partnership_id/view/:view_id', component: PartnershipSetupComponent, canActivate: [AuthGuard] },
  { path: 'partnership-report', component: PartnershipReportComponent, canActivate: [AuthGuard] },
  { path: 'customer-partnership-report', component: CustomerPartnershipReportComponent, canActivate: [AuthGuard] },


  { path: 'resetpassword', component: ResetpasswordComponent },
  { path: 'changepassword', component: ChangepasswordComponent },
  { path: 'emp-detail', component: EmpDetailsComponent, canActivate: [AuthGuard] },
  { path: 'customer-report', component: CustomerReportComponent, canActivate: [AuthGuard] },
  { path: 'employee-report', component: EmployeeReportComponent, canActivate: [AuthGuard] },
  { path: 'productInService', component: ProductsInServiceComponent, canActivate: [AuthGuard] },
  { path: 'servicesInproduct', component: ServicesInProductComponent, canActivate: [AuthGuard] },
  { path: 'productReport', component: ProductReportComponent, canActivate: [AuthGuard] },
  { path: 'productUsageReport', component: ProductUsageReportComponent, canActivate: [AuthGuard] },
  { path: 'dynamic-report', component: DynamicReportComponent, canActivate: [AuthGuard] },
  { path: 'transactionalSMS', component: TransactionalsmsComponent, canActivate: [AuthGuard] },
  { path: 'promotionalSMS', component: PromotionalsmsComponent, canActivate: [AuthGuard] },
  { path: 'TransactionalSMSReport', component: TransactionalSmsReportComponent, canActivate: [AuthGuard] },
  { path: 'promotionalSMSReport', component: PromotionalsmsReportComponent, canActivate: [AuthGuard] },
  { path: 'incentive-setup', component: IncentiveSetupComponent, canActivate: [AuthGuard] },
  { path: 'incentive-setup-grid', component: IncentiveSetupGridComponent, canActivate: [AuthGuard] },
  { path: 'WhatsAppMsgTemplate', component: WhatsAppTemplateComponent, canActivate: [AuthGuard] },
  { path: 'AddEditWhatsAppMsgTemplate', component: AddWhatsAppTemplateComponent, canActivate: [AuthGuard] },
  { path: 'AddEditWhatsAppMsgTemplate/:id', component: AddWhatsAppTemplateComponent, canActivate: [AuthGuard] },
  { path: 'membership', component: MembershipComponent },
  { path: 'document', component: DocumentsComponent, canActivate: [AuthGuard] },
  { path: 'membership-setup', component: MembershipSetupComponent, canActivate: [AuthGuard] },
  { path: 'membership-setup/:service_offered_id/type/:type', component: MembershipSetupComponent, canActivate: [AuthGuard] },
  { path: 'membership-setup/:service_offered_id/type/:type/view/:view_id', component: MembershipSetupComponent, canActivate: [AuthGuard] },
  { path: 'memReport', component: MemReportComponent, canActivate: [AuthGuard] },
  { path: 'package-report', component: PackageReportComponent, canActivate: [AuthGuard] },
  { path: 'offerReport', component: OfferReportComponent, canActivate: [AuthGuard] },

  { path: 'inventory-manager', component: InventoryManagerComponent, canActivate: [AuthGuard] },
  { path: 'inventory-manager/:inventory_item_id', component: InventoryManagerComponent, canActivate: [AuthGuard] },
  { path: 'add-inventory-manager', component: AddInventoryManagerComponent, canActivate: [AuthGuard] },
  { path: 'add-inventory-manager/:inventory_manager_id/product/:product_id', component: AddInventoryManagerComponent, canActivate: [AuthGuard] },
  { path: 'add-inventory-manager/:inventory_manager_id/view/:view_id/product/:product_id', component: AddInventoryManagerComponent, canActivate: [AuthGuard] },
  { path: 'add-inventory-manager/product/:product_id', component: AddInventoryManagerComponent, canActivate: [AuthGuard] },


  { path: 'sell-product', component: SellProductComponent, canActivate: [AuthGuard] },

  { path: 'add-product', component: AddProductComponent, canActivate: [AuthGuard] },
  { path: 'add-product/:inventory_manager_id/product/:product_id', component: AddProductComponent, canActivate: [AuthGuard] },
  { path: 'add-product/:inventory_manager_id/view/:view_id/product/:product_id', component: AddProductComponent, canActivate: [AuthGuard] },
  { path: 'add-product/:inventory_manager_id/product/:product_id/disable/:disable', component: AddProductComponent, pathMatch: 'full' },
  { path: 'add-product/product/:product_id', component: AddProductComponent, canActivate: [AuthGuard] },

  // { path: 'print-cusBill', component: PrintCusBillComponent },
  { path: 'print-cusBill/bill_no/:bill_no/customer_id/:customer_id', component: PrintCusBillComponent },

  { path: 'add-usables', component: AddUsablesComponent, canActivate: [AuthGuard] },
  { path: 'add-usables/:inventory_manager_id/usables/:usables_id', component: AddUsablesComponent, canActivate: [AuthGuard] },
  { path: 'add-usables/:inventory_manager_id/view/:view_id/usables/:usables_id', component: AddUsablesComponent, canActivate: [AuthGuard] },
  { path: 'add-usables/:inventory_manager_id/usables/:usables_id/disable/:disable', component: AddUsablesComponent, pathMatch: 'full' },
  { path: 'add-usables/usables/:usables_id', component: AddUsablesComponent, canActivate: [AuthGuard] },

  // Attendance routes
  { path: 'attendance', component: DailyAttendanceComponent, canActivate: [AuthGuard] },
  { path: 'daily-attendance', component: DailyAttendanceComponent, canActivate: [AuthGuard] },
  { path: 'attendance-dashboard', component: AttendanceDashboardComponent, canActivate: [AuthGuard] },
  { path: 'weekly-roster', component: WeeklyRosterComponent, canActivate: [AuthGuard] },
  { path: 'individual-roster', component: WeekOffManagementComponent, canActivate: [AuthGuard] },
  { path: 'monthly-calendar', component: MonthlyClaendarComponent, canActivate: [AuthGuard] },
  { path: 'manageSalons', component: ManageSalonsComponent, canActivate: [AuthGuard] },
  { path: 'add-salon', component: AddSalonComponent, canActivate: [AuthGuard] },
  { path: 'add-salon/:salon_id', component: AddSalonComponent, canActivate: [AuthGuard] },

  { path: 'meta-template-approval', component: MetaTemplateApprovalComponent, canActivate: [AuthGuard] },
  { path: 'meta-template-approval/:id', component: MetaTemplateApprovalComponent, canActivate: [AuthGuard] },
  { path: 'whatsAppBulk', component: BulkWhatsappComponent, canActivate: [AuthGuard] },
  { path: 'whatsapp-chat', component: WhatsappChatComponent, canActivate: [AuthGuard] },
  { path: 'whatsapp-report', component: WhatsAppSentReportComponent, canActivate: [AuthGuard] },
  { path: 'whatsapp-campaign-report', component: WhatsappCampaignReportComponent, canActivate: [AuthGuard] },
  { path: 'credits-history', component: CreditsHistoryComponent, canActivate: [AuthGuard] },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts